import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { SessionCookieService } from '@docpath/linces-angular-components/common';
import { DpSinclairTableWidgetsService, DpWidgets, DpWidgetsModule } from '@docpath/webcomponents';
import { CloudService } from 'src/app/shared/services/cloud.service';

import { AppSession } from '../../shared/models/app-session.model';
import { buildHomeWidgets } from './models/home-widgets';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  standalone: true,
  imports: [DpWidgetsModule]
})
export class HomeComponent implements OnInit, OnDestroy {
  renderWidgets = true;
  widgets: DpWidgets;

  idRefreshProcess!: ReturnType<typeof setTimeout>;

  private readonly sessionCookieService = inject(SessionCookieService);
  private readonly cloudService = inject(CloudService);
  private readonly sinclairTableWidgetsService = inject(DpSinclairTableWidgetsService);

  constructor() {
    this.widgets = this.createWidgets();
  }

  ngOnInit(): void {
    const appSession = this.sessionCookieService.getSessionCookie()?.app as AppSession;
    this.initRefreshProcess(appSession.refreshLastHour * 1000);
  }

  ngOnDestroy() {
    if (this.idRefreshProcess) {
      clearInterval(this.idRefreshProcess);
    }
  }

  private createWidgets(): DpWidgets {
    return buildHomeWidgets(
      this.cloudService.isModeCloud(),
      this.sinclairTableWidgetsService
    );
  }

  private initRefreshProcess(refreshLastHour: number) {
    this.idRefreshProcess = setInterval(() => {
      this.reloadWidgets();
    }, refreshLastHour);
  }

  private reloadWidgets(): void {
    this.renderWidgets = false;
    this.widgets = this.createWidgets();

    queueMicrotask(() => {
      this.renderWidgets = true;
    });
  }
}